<template>
  <div class="chart">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>
